<i18n src="@/i18n/enums/support_urgency.json"></i18n>
<template>
	<FormSelect :options="options" localized :default-option-label="defaultOptionLabel" :value="value" @input:object="handleSelect" :loading="isLoading" v-bind="$attrs" />
</template>
<script>
import SupportSubjects from "@/API/backoffice/SupportSubjects.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSelect from "@/components/FormSelect.vue"

import {options as SupportUrgencyOptions} from "@/enums/support_urgency.js"

export default {
	name: "SupportSubjectSelect",
	mixins: [LoadingMixins],
	props: {
		value: [String, Number],
		defaultOptionLabel: {
			type: String,
			default: "Selecione"
		}
	},
	components: {
		FormSelect
	},
	data() {
		return {
			list: []
		}
	},
	computed: {
		/**
		 * Subjects with the urgency appended to the label
		 * @returns {Array}
		 */
		options() {
			const urgencies = translateEnum(this, SupportUrgencyOptions, 'support_urgency.')

			return this.list.map(item => {

				const urgency = urgencies.find(option => option.id == item.urgency)

				if (!urgency) return item

				const suffix = ` (${urgency.label})`

				return {
					...item,
					label: this.appendSuffix(item.label, suffix),
					label_locale: this.appendSuffix(item.label_locale, suffix)
				}
			})
		}
	},
	methods: {
		/**
		 * Append the suffix to a plain or localized label
		 * @param label
		 * @param suffix
		 * @returns {String|Object|undefined}
		 */
		appendSuffix(label, suffix) {

			if (!label) return label

			if (typeof label === "string") return `${label}${suffix}`

			return Object.keys(label).reduce((acc, uti) => {
				acc[uti] = `${label[uti]}${suffix}`
				return acc
			}, {})
		},
		handleSelect(evt){
			this.$emit('input', evt?.id)
			this.$emit('input:object', evt)
			this.$emit('update:departments', evt?.departments)
		},
		/**
		 * Action load
		 * @returns {Promise<boolean>}
		 */
		async load() {

			this.loading()

			const [err, res] = await SupportSubjects.getSelect()

			this.loaded()

			if (err) {
				// TODO...
				this.list = []
				return false
			}

			this.list = res.data.data

			return true
		}
	},
	mounted() {
		this.load()
	}
}
</script>
